Vue.component('MpModuleCookiesConsent', {
    props: {},
    mixins: [MpCookieConsent],
    data: function() {
        return {
            title: '',
            intro: '',

            rejectLabel: '',
            acceptLabel: '',
            saveLabel: '',

            cookieList: [],
            openCategories: [],

            isClosed: true,
            isInitialized: false,
        };
    },

    computed: {},

    methods: {
        open: function() {
            this.updateTypeStatus();
            CookieManager.statsView(CookieManager.VIEW_CONFIG);

            noScroll.on();
            this.isClosed = false;
        },

        close: function(ev) {
            if (ev) { CookieManager.statsClose(); }
            MpEventBus.$emit(EVENT_COOKIE_CONSENT_HIDE);

            noScroll.off();
            this.isClosed = true;
        },

        addDomCookieCategory: function(cookieCategory) {
            var category = {};

            category.id = cookieCategory.querySelector('input').id;
            category.checked = cookieCategory.querySelector('input').getAttribute('checked');
            category.disabled = cookieCategory.querySelector('input').getAttribute('disabled');
            category.name = cookieCategory.querySelector('.js-cookie-category-name').innerHTML;
            category.desc = cookieCategory.querySelector('.js-cookie-category-desc').innerHTML;
            category.moreLink = cookieCategory.querySelector('.js-more-info').innerHTML;

            category.cookieList = [];

            cookieCategory.querySelectorAll('.js-cookie-definition').forEach(function(cookie) {
                category.cookieList.push(cookie.innerHTML);
            });

            this.cookieList.push(category);
        },

        save: function(ev) {
            CookieManager.setCookie(CookieManager.CONSENT, COOKIE_VERSION, 10*365, '/');
            CookieManager.setCookie('mp_chkcookie_'+CookieManager.TYPE_ANALYTICS, this.allowedTypes[CookieManager.TYPE_ANALYTICS], 10*365, '/');
            CookieManager.setCookie('mp_chkcookie_'+CookieManager.TYPE_MARKETING, this.allowedTypes[CookieManager.TYPE_MARKETING], 10*365, '/');

            if (ev) {
                CookieManager.statsAction(CookieManager.ACTION_SAVE, this.allowedTypes[CookieManager.TYPE_ANALYTICS], this.allowedTypes[CookieManager.TYPE_MARKETING]);
            }

            if (typeof(GTMManager) !== 'undefined' && !GTMManager.getInstance().isLoaded()) {
                GTMManager.getInstance().loadGTM();
            }

            this.updateIframes();
            this.close();
        },

        init: function() {
            if (this.isInitialized) {
                return;
            }

            this.updateTypeStatus();

            MpEventBus.$on(EVENT_COOKIE_CONSENT_SHOW, this.open);
            this.isInitialized = true;
        },

        toggleCategory: function(categoryId) {
            var pos = this.openCategories.indexOf(categoryId);

            if (pos === -1) {
                this.openCategories.push(categoryId);
            } else {
                this.openCategories.splice(pos, 1);
            }
        },

        isCategoryOpen: function(categoryId) {
            return (this.openCategories.indexOf(categoryId) !== -1);
        },

        toggleCategoryConsent: function(categoryId) {
            this.allowedTypes[categoryId] = !this.allowedTypes[categoryId];
        },

        acceptAll: function() {
            this.allowedTypes[CookieManager.TYPE_ANALYTICS] = true;
            this.allowedTypes[CookieManager.TYPE_MARKETING] = true;
            CookieManager.statsAction(CookieManager.ACTION_ACCEPT);
            this.save();
        },

        rejectAll: function() {
            this.allowedTypes[CookieManager.TYPE_ANALYTICS] = false;
            this.allowedTypes[CookieManager.TYPE_MARKETING] = false;
            CookieManager.statsAction(CookieManager.ACTION_REJECT);
            this.save();
        },
    },

    mounted: function() {
        this.title = this.$refs.ssrCookiesConsent.querySelector('.js-cookies-title').innerHTML;
        this.intro = this.$refs.ssrCookiesConsent.querySelector('.js-cookies-intro').innerHTML;
        this.rejectLabel = this.$refs.ssrCookiesConsent.querySelector('.js-cookies-rejectall').innerHTML;
        this.acceptLabel = this.$refs.ssrCookiesConsent.querySelector('.js-cookies-acceptall').innerHTML;
        this.saveLabel = this.$refs.ssrCookiesConsent.querySelector('.js-cookies-save').innerHTML;

        this.$refs.ssrCookiesConsent.querySelectorAll('.js-cookie-category').forEach(this.addDomCookieCategory);

        this.init();
    },

    destroyed: function() {
        MpEventBus.$off(EVENT_COOKIE_CONSENT_SHOW, this.open);
    },

    template: '\
    <div class="cookies-consent" :class="{\'cookies-consent--shown\': !isClosed}">\
        <div ref="ssrCookiesConsent" v-if="!isInitialized">\
            <slot></slot>\
        </div>\
        <a class="cookies-consent__close" href="#" @click.prevent="close"></a>\
        <div class="cookies-consent__actions">\
            <div class="cookies-consent__action cookies-consent__action--revokeall">\
                <a class="btn-link btn-link--dark" href="#" @click.prevent="rejectAll">{{rejectLabel}}</a>\
            </div>\
            <div class="cookies-consent__action">\
                <a class="btn-ghost btn-ghost--soft" href="#" @click.prevent="save">{{saveLabel}}</a>\
            </div>\
            <div class="cookies-consent__action">\
                <a class="btn btn--cta" href="#" @click.prevent="acceptAll">{{acceptLabel}}</a>\
            </div>\
        </div>\
        <div class="cookies-consent__content">\
            <h2 class="cookies-consent__title">{{title}}</h2>\
            <p class="cookies-consent__intro">{{intro}}</p>\
            <div class="cookies-consent__item" v-for="category in cookieList" v-if="allowedTypes">\
                <input class="cookies-consent__item-check" type="checkbox" :name="category.id" :id="category.id" :checked="category.checked" :disabled="category.disabled" v-model="allowedTypes[category.id]">\
                <label class="cookies-consent__item-label" :for="category.id">\
                    <span>{{category.name}}</span>\
                    <span></span>\
                </label>\
                <p class="cookies-consent__item-desc" v-html="category.desc"></p>\
                <a href="#" class="cookies-consent__item-more" @click.prevent="toggleCategory(category.id)">{{category.moreLink}}</a>\
                <ul class="cookies-consent__item-list" :class="{\'cookies-consent__item-list--visible\': isCategoryOpen(category.id)}">\
                    <li class="cookies-consent__definition" v-for="cookie in category.cookieList" v-html="cookie">\
                    </li>\
                </ul>\
            </div>\
        </div>\
    </div>',
});